const e = "af.filter-sidebar.clear-filters", s = class s extends CustomEvent {
  constructor() {
    super(e, { bubbles: !0, composed: !0 });
  }
};
s.EVENT_NAME = e;
let t = s;
export {
  e as EVENT_NAME,
  t as default
};
//# sourceMappingURL=ClearFiltersEvent.js.map
